'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border-radius: ', ';\n  border: solid ', '\n    ', ';\n  font-size: ', ';\n  padding: 0 ', ';\n  height: ', ';\n  color: ', ';\n  background-color: ', '\n  font-family: ', ';\n  outline: 0;\n  padding-right: ', '\n  &:focus {\n    box-shadow: ', ';\n  }\n  &::placeholder {\n    color: ', ';\n  }\n'], ['\n  width: 100%;\n  border-radius: ', ';\n  border: solid ', '\n    ', ';\n  font-size: ', ';\n  padding: 0 ', ';\n  height: ', ';\n  color: ', ';\n  background-color: ', '\n  font-family: ', ';\n  outline: 0;\n  padding-right: ', '\n  &:focus {\n    box-shadow: ', ';\n  }\n  &::placeholder {\n    color: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        ', ';\n      '], ['\n        ', ';\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      ', ';\n    '], ['\n      ', ';\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  transform: translateY(-50%);\n  line-height: 0;\n'], ['\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  transform: translateY(-50%);\n  line-height: 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Loader = require('../Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var horizontalPadding = 10;

var Input = _styledComponents2.default.input(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.largeBorderRadius;
}, (0, _polished.rem)(1), function (_ref2) {
  var theme = _ref2.theme,
      error = _ref2.error;
  return error ? theme.color.danger : theme.separatorColor;
}, (0, _polished.rem)(14), (0, _polished.rem)(horizontalPadding), (0, _polished.rem)(36), function (_ref3) {
  var theme = _ref3.theme;
  return theme.textColor;
}, function (_ref4) {
  var theme = _ref4.theme,
      error = _ref4.error,
      disabled = _ref4.disabled;

  if (error) {
    return (0, _styledComponents.css)(_templateObject2, theme.color.dangerBg);
  }

  if (disabled) {
    return (0, _styledComponents.css)(_templateObject2, theme.color.disabled);
  }

  return (0, _styledComponents.css)(_templateObject3, theme.color.primaryBg);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily;
}, function (_ref6) {
  var haveIcon = _ref6.haveIcon,
      loading = _ref6.loading;

  if (loading && haveIcon) {
    return (0, _styledComponents.css)(_templateObject2, (0, _polished.rem)(60));
  } else if (haveIcon || loading) {
    return (0, _styledComponents.css)(_templateObject2, (0, _polished.rem)(40));
  }

  return (0, _styledComponents.css)(_templateObject3, (0, _polished.rem)(horizontalPadding));
}, function (_ref7) {
  var error = _ref7.error,
      theme = _ref7.theme;
  return error ? '' : theme.focusShadow;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.form.placeholderColor;
});

var Wrapper = _styledComponents2.default.div(_templateObject4);

var StyledIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject5, function (_ref9) {
  var loading = _ref9.loading;
  return loading ? (0, _polished.rem)(40) : (0, _polished.rem)(15);
});

var StyledLoader = _styledComponents2.default.div(_templateObject5, (0, _polished.rem)(15));

var CompInput = function (_PureComponent) {
  _inherits(CompInput, _PureComponent);

  function CompInput() {
    _classCallCheck(this, CompInput);

    return _possibleConstructorReturn(this, (CompInput.__proto__ || Object.getPrototypeOf(CompInput)).apply(this, arguments));
  }

  _createClass(CompInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['className']);

      return _react2.default.createElement(Wrapper, {
        className: className
      }, _react2.default.createElement(Input, _extends({}, restProps, {
        innerRef: this.props.inputRef,
        haveIcon: !!this.props.icon,
        loading: !!this.props.loading,
        id: this.props.id || this.context.id
      })), this.props.icon && _react2.default.createElement(StyledIcon, {
        loading: !!this.props.loading,
        name: this.props.icon
      }), this.props.loading && _react2.default.createElement(StyledLoader, null, _react2.default.createElement(_Loader2.default, null)));
    }
  }]);

  return CompInput;
}(_react.PureComponent);

CompInput.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  inputRef: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};
CompInput.defaultProps = {
  className: '',
  id: null,
  icon: null,
  loading: false,
  inputRef: function inputRef() {}
};
CompInput.contextTypes = {
  id: _propTypes2.default.string
};
exports.default = CompInput;
CompInput.__docgenInfo = [{
  'description': '',
  'displayName': 'CompInput',
  'methods': [],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'icon': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'inputRef': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'loading': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    }
  },
  'context': {
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Input/index.js'] = {
    name: 'CompInput',
    docgenInfo: CompInput.__docgenInfo,
    path: 'src/Input/index.js'
  };
}